module.exports = {AWS_STACK_DOMAIN:'daredrop.com',AWS_ACCOUNT_ID:'685756249129'}